import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface BreadcrumbState {
    leafLabel: string | null;
    // The crumb's own text where it is not the record's name (the new design names a case by its number);
    // readers of the record's name, such as the AI panel, keep reading `leafLabel`.
    leafCrumb?: string | null;
    // Identity of the entity the label describes; lets Breadcrumbs reject a stale
    // label while the next page's data is still loading (see getBreadcrumbLeafKey).
    leafKey: string | null;
}

const initialState: BreadcrumbState = { leafLabel: null, leafKey: null };

const breadcrumbSlice = createSlice({
    name: 'breadcrumb',
    initialState,
    reducers: {
        setBreadcrumbLeaf(state, action: PayloadAction<{ leafLabel: string; leafKey: string; leafCrumb?: string }>) {
            state.leafLabel = action.payload.leafLabel;
            state.leafCrumb = action.payload.leafCrumb ?? null;
            state.leafKey = action.payload.leafKey;
        },
        clearBreadcrumbLeaf(state, action: PayloadAction<{ leafKey: string; leafLabel: string } | undefined>) {
            // Only clear when the slot still holds exactly what the leaving page set, so a
            // sibling page that already claimed it (or an in-place label update on the same
            // route) is not wiped. Pass `undefined` to force-clear.
            const payload = action.payload;
            if (payload === undefined || (state.leafKey === payload.leafKey && state.leafLabel === payload.leafLabel)) {
                state.leafLabel = null;
                state.leafCrumb = null;
                state.leafKey = null;
            }
        },
    },
});

export const { setBreadcrumbLeaf, clearBreadcrumbLeaf } = breadcrumbSlice.actions;
export default breadcrumbSlice.reducer;
